import { create } from "zustand";

interface AddOrderData {
  address: string;
  city: string;
  state: string;
  postal_code: string;
  person_name: string;
  email: string;
}

interface ServiceDrawerState {
  id: number | string;
  isOpen: boolean;
  isScheduleOrderOpen: boolean;
  isCancelOrderOpen: boolean;
  vendor: string;
  onOpen: (id?: number | string) => void;
  onClose: (id?: number | string) => void;
  onOpenSchedule: (id?: number | string) => void;
  onCloseSchedule: (id?: number | string) => void;
  onOpenCancel: (id?: number | string) => void;
  onCloseCanel: () => void;
  syncOrder: number;
  setSyncOrder: () => void;
}

export const useServiceDrawer = create<ServiceDrawerState>((set) => ({
  syncOrder: 0,
  id: "",
  isOpen: false,
  isCancelOrderOpen: false,
  isScheduleOrderOpen: false,
  vendor: "",
  onOpen: (id) => set({ isOpen: true, id }),
  onClose: (id) => set({ isOpen: false, id }),
  onOpenSchedule: (id) => set({ isScheduleOrderOpen: true, id }),
  onCloseSchedule: (id) => set({ isScheduleOrderOpen: false, id }),
  onOpenCancel: (id) => set({ isCancelOrderOpen: true, id }),
  onCloseCanel: () => set({ isCancelOrderOpen: false, id: "" }),
  setSyncOrder: () => set((state) => ({ syncOrder: state.syncOrder + 1 })),
}));
